import { TypeBoolean } from "./TypeBoolean";

export class TypeOptions {
	
	cover: boolean;
	/**
	 * check list
	 */
	protocol: boolean;
	
	roofPlanOverview: boolean;
	
	roofPlanSubFrame: boolean;
	
	stringOverview: boolean;
	
	subGenerators: boolean;
	
	items: boolean;
	
}

